/*
 * @Author: Liux
 * @Date: 2020-01-02 02:14:38
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 14:24:52
 */
import {
  Component,
  OnInit,
  Inject,
  Optional,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { CONFIG_DATA } from './common/ad-alert-config-inject-key';
import { OverlayRef } from '@angular/cdk/overlay';
import { AdAlertConfig } from './common/ad-alert-config';

@Component({
  selector: 'ad-alert',
  templateUrl: './ad-alert.component.html',
  styleUrls: ['./ad-alert.component.scss'],
})
export class AdAlertComponent implements OnInit, OnDestroy {
  constructor(
    @Optional() @Inject(CONFIG_DATA) private context: any,
    private elRef: ElementRef
  ) {
    this.text = context ? context.content : '';
    this.overlayRef = context ? context.overlayRef : null;
    this.overlayConfig = context ? context.config : new AdAlertConfig();
  }

  closeFun: any;
  overlayRef: OverlayRef;
  overlayConfig: AdAlertConfig;
  setT: any;
  text = '';

  ngOnInit() {
    this.applyAutomaticalClose(this.overlayRef, this.overlayConfig);
    this.closeFun = this.close.bind(this);
    this.hostElementMouseenter = this.hostElementMouseenter.bind(this);
    this.hostElementMouseleave = this.hostElementMouseleave.bind(this);
    this.hostElementClick = this.hostElementClick.bind(this);
    this.elRef.nativeElement.addEventListener(
      'mouseenter',
      this.hostElementMouseenter
    );
    this.elRef.nativeElement.addEventListener(
      'mouseleave',
      this.hostElementMouseleave
    );
    this.elRef.nativeElement.addEventListener('click', this.hostElementClick);
  }

  hostElementMouseenter() {
    clearInterval(this.setT);
  }

  hostElementClick() {
    clearInterval(this.setT);
    this.close();
  }

  hostElementMouseleave() {
    this.applyAutomaticalClose(this.overlayRef, this.overlayConfig);
  }

  ngOnDestroy(): void {
    clearInterval(this.setT);
    this.elRef.nativeElement.removeEventListener(
      'mouseenter',
      this.hostElementMouseenter
    );
    this.elRef.nativeElement.addEventListener(
      'mouseleave',
      this.hostElementMouseleave
    );
    this.elRef.nativeElement.addEventListener('click', this.hostElementClick);
    this.context = null;
  }

  close() {
    this.context && this.context.close
      ? this.context.close(this.overlayRef)
      : this.overlayRef.dispose();
  }

  applyAutomaticalClose(olref: OverlayRef, config: AdAlertConfig) {
    if (
      this.overlayConfig.autoClose !== false &&
      this.overlayConfig.autoClose > 0
    ) {
      let intervalValue = 5000;
      if (
        typeof config.autoClose === 'number' &&
        !isNaN(config.autoClose) &&
        config.autoClose > 0
      ) {
        intervalValue = config.autoClose;
      }
      clearInterval(this.setT);
      this.setT = setInterval(() => {
        this.close();
      }, intervalValue);
    }
  }
}
